import { RefObject } from "react";
import { LoaderMessage } from "../../../../../components/loaderMessage/loaderMessage";
import { NarAgentGridData } from "../../../../../data-model/medicalPaOrdersModel";
import NarGridBg from "../../../../../svg/nar-grid-bg";
import NarAgentGridTable from "./narAgentGridTable";

export interface NarAgentGridResultsPanelProps {
  tableRef: RefObject<HTMLDivElement>;
  isLoading: boolean;
  apiData: NarAgentGridData[];
  clientId: string;
  onRefetch: () => Promise<void>;
}

/**
 * Loading, table, and empty states for NAR Agent Grid search results.
 */
const NarAgentGridResultsPanel = ({
  tableRef,
  isLoading,
  apiData,
  clientId,
  onRefetch,
}: NarAgentGridResultsPanelProps) => (
  <div className="flex min-h-0 flex-1 flex-col">
    {isLoading ? (
      <div className="flex flex-1 items-center justify-center">
        <LoaderMessage message="Loading Auth Grid" />
      </div>
    ) : apiData.length > 0 ? (
      <div className="flex-1 overflow-hidden">
        <NarAgentGridTable
          narAgentGridTableRef={tableRef}
          clientId={clientId}
          exportingInProgress={false}
          apiData={apiData}
          onAuthGridRefetch={onRefetch}
        />
      </div>
    ) : (
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="mb-2 text-lg font-medium">
          <NarGridBg />
        </div>
        <div className="text-center text-small text-primaryGray-3">
          Select the Insurance and enter the J-codes to view the results
        </div>
      </div>
    )}
  </div>
);

export default NarAgentGridResultsPanel;
